import create from 'zustand';

interface MenuStoreState {
  opened: boolean;
  switchOpen: () => void;
  setOpened: (opened: boolean) => void;
}

export const useMenuStore = create<MenuStoreState>((set) => {
  return {
    opened: false,
    switchOpen: () => set((state) => ({ opened: !state.opened })),
    setOpened: (opened) => set({ opened }),
  };
});
